/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-08-17 15:59:55
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-11-24 11:02:54
 * @FilePath: \sea-page-game\src\utils\api.js
 */
import { getMainDomain } from './util'
var initUrl = "";
if (window.location.hostname.indexOf('192.168') !== -1 || window.location.hostname.indexOf('test') !== -1) {
  initUrl = "//sy.rastargames.local.com";
} else {
  initUrl = `//sy${getMainDomain()}`;
}
export default {
  // 初始化
  syInit: initUrl + "/websdk/v2/init/index/",
  // 收集设备信息接口
  syWebDevice: "//collect.rastargames.com/web/device/cl/",
  // 埋点数据上报接口
  syWebDot: "//collect.rastargames.com/web/dot/cl/",
  // 错误日志上报接口
  syWebErrorlog: "//collect.rastargames.com/web/errorlog/cl/",
  // sdk 数据上报
  RaStarUpload: "//collect.rastargames.com/web/rolelog/cl/",

};